var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1152 0H2.2793C1.40805 0 0.697266 0.735876 0.697266 1.63965V12.5707C0.697266 13.4714 1.40489 14.2103 2.2793 14.2103H17.1152C17.9843 14.2103 18.6973 13.4769 18.6973 12.5707V1.63965C18.6973 0.738937 17.9896 0 17.1152 0ZM16.8968 1.0931L9.73081 8.52011L2.50286 1.0931H16.8968ZM1.75195 12.3443V1.86079L6.83129 7.07998L1.75195 12.3443ZM2.49772 13.1172L7.58026 7.84956L9.36117 9.67949C9.56733 9.89133 9.90001 9.89064 10.1053 9.67781L11.8418 7.87809L16.8968 13.1172H2.49772ZM17.6426 12.3443L12.5876 7.10516L17.6426 1.866V12.3443Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.e58669b618b73830e9d126800cb93c36.svg";
export { ForwardRef as ReactComponent };